import gql from "graphql-tag";

export default gql`
	query WritebackCounts($startDate: String, $endDate: String, $company: String, $school: String, $type: String) {
		WritebackCounts(startDate: $startDate, endDate: $endDate, company: $company, school: $school, type: $type) {
			type
			created_at
			status
		}
	}
`;
